import { Link } from "react-router-dom";
import { ArrowRight, Briefcase } from "lucide-react";
import PageHero from "../components/PageHero";

const Careers = () => {
  return (
    <>
      <PageHero
        eyebrow="Careers"
        title="Join HawkEdge AI Advisory."
      />

      <section
        className="py-24 sm:py-32 border-b border-white/10"
        data-testid="careers-empty"
      >
        <div className="max-w-3xl mx-auto px-6 sm:px-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 border border-white/25 mb-8">
            <Briefcase size={20} className="text-white/70" strokeWidth={1.5} />
          </div>
          <p className="text-[10px] font-sans-modern uppercase tracking-[0.3em] text-white/55 mb-4">
            Current openings
          </p>
          <p className="font-serif-display text-3xl sm:text-4xl text-white leading-snug">
            Currently, there are no openings available.
          </p>
          <p className="mt-6 max-w-xl mx-auto text-base font-sans-modern font-light text-white/60 leading-relaxed">
            We hire selectively. If you believe your background would add to our
            senior bench, feel free to reach out — we'll keep your note on file.
          </p>
          <Link
            to="/contact"
            data-testid="careers-cta"
            className="mt-10 inline-flex items-center justify-center h-12 px-10 border border-white/25 text-white font-sans-modern font-semibold text-sm tracking-wide hover:bg-white/5 hover:border-white/50 transition-colors"
          >
            Introduce yourself
            <ArrowRight size={16} className="ml-2" />
          </Link>
        </div>
      </section>
    </>
  );
};

export default Careers;
